import useStyles from "isomorphic-style-loader/useStyles";
import _ from "lodash";
import React from "react";
import { unitPrice } from "../../../../../../../utils/product";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { withScroll } from "../../fragment/scroll-hook";
import classes from './style.module.scss';

const OrderItem = props => {
    useStyles(classes)
    const {intl, status, detail, selected, clickHandler} = props

    return (
        <li className={classes.New_order_list_li} onClick={(evt) => { clickHandler(evt, detail) }}>
            <div className={classes.New_order_list_item_title_box}>
                <div className={classes.Cell}>
                    <span>
                        <label className={classes.Li_Order_Number}>{intl.formatMessage({ id: 'order_no' })}</label>
                        <span >{detail?.id}</span>
                    </span>
                </div>
                <div className={classes.Cell} style={{ textAlign: 'right' }}>
                    <span className={classes.OrderStatus}>{status(detail?.fulfillmentStatus)}</span>
                </div>
            </div>
            <div className={classes.New_order_list_img_box}>
                <div className={classes.New_order_list_select}>
                    {
                        selected ?
                            <Iconfont className={classes.New_order_list_select_span} style={{ color: '#222222' }}>&#xe658;</Iconfont> :
                            <Iconfont className={classes.New_order_list_select_span} style={{ color: '#cacaca' }}>&#xe65a;</Iconfont>
                    }
                </div>
                <div className={classes.New_order_list_item}>
                    <ul>
                        {detail?.orderItems.map((item, index) => (
                            <li key={index}>
                                <img src={item.productImageUrl} />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className={classes.New_order_list_total_box}>
                {intl.formatMessage({id: 'count_items'},{total: detail.orderItems.length})}
                <span className={classes.MoneyBox}>
                    <label className={classes.TotalLabel}>{intl.formatMessage({ id: 'total' })}</label>
                    <span >{unitPrice(detail?.orderTotal)}</span>
                </span>
            </div>
        </li>
    )
}

export const OrderList = withScroll(props => {
    useStyles(classes)
    const { intl, orders, bottomPx, isApp, innerRef } = props

    const TOTAL_STATUS_UNPAID = 0;       //未付款订单
    const TOTAL_STATUS_PROCCESSING = 1;      //仓库正在打包与包含废弃状态paid一起存在的订单
    const TOTAL_STATUS_SHIPPED = 2;      //运送中的订单
    const TOTAL_STATUS_CANCELED = 3;     //已取消订单
    const TOTAL_STATUS_REVIEW = 4;        //已完成订单

    const status = (value) => {
        let label
        switch (value) {
            case TOTAL_STATUS_UNPAID:
                label = <span>{intl.formatMessage({ id: 'unpaid' })}</span>
                break
            case TOTAL_STATUS_PROCCESSING:
                label = <span>{intl.formatMessage({ id: 'processing' })}</span>
                break
            case TOTAL_STATUS_SHIPPED:
                label = <span>{intl.formatMessage({ id: 'shipped' })}</span>
                break
            case TOTAL_STATUS_CANCELED:
                label = <span>{intl.formatMessage({ id: 'order_status_canceled' })}</span>
                break
            case TOTAL_STATUS_REVIEW:
                label = <span>{intl.formatMessage({ id: 'order_status_confirmed' })}</span>
                break
            //   case STATUS_PENDING:
            //     label = <span>{intl.formatMessage({id: 'order_status_pendding'})}</span>
            //     break
            //   case STATUS_REVIEWING:
            //     label = <span>{intl.formatMessage({id: 'order_status_paid'})}</span>
            //     break
            //   case STATUS_PROCESSING:
            //     label = <span>{intl.formatMessage({id: 'order_status_processing'})}</span>
            //     break
            //   case STATUS_SHIPPED:
            //     label = <span>{intl.formatMessage({id: 'order_status_shipped'})}</span>
            //     break
            //   case STATUS_PARTIALLY_REFUNDED:
            //     label = <span>{intl.formatMessage({id: 'order_status_partially_refunded'})}</span>
            //     break
            //   case STATUS_REFUNDED:
            //     label = <span>{intl.formatMessage({id: 'order_status_refunded'})}</span>
            //     break
            //   case STATUS_CANCELED:
            //     label = <span>{intl.formatMessage({id: 'order_status_canceled'})}</span>
            //     break
            //   case STATUS_HELD:
            //     label = <span>{intl.formatMessage({id: 'order_status_held'})}</span>
            //     break
            //   case STATUS_CONFIRMED:
            //     label = <span>{intl.formatMessage({id: 'order_status_confirmed'})}</span>
            //     break
            default:
                label = ''
        }

        return label
    }

    return (
        <div className={classes.OrderList} ref={innerRef} style={{height: `calc(100vh - ${isApp ? bottomPx(131):bottomPx(205)})`}}>
            <ul>
                {
                    orders?.map((item, index) => (
                        <OrderItem {...props} status={status} selected={item?.selected} key={item?.id} detail={item}/>
                    ))
                }
                {
                    props?.loadingDom
                }
            </ul>
        </div>
    )
})